import { Privileges } from 'src/app/corporate-portal/models/privileges.model';
import { BrokerMaster } from './broker-master.model';

export class Broker extends Privileges {
  brokerMaster: BrokerMaster = new BrokerMaster();
}
